import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchUserById, fetchUserBalance } from "../../services/api";
import ProfileInfo from "./ProfileInfo";
import QrCodeCard from "./QrCodeCard";
import BalanceCard from "./BalanceCard";
import QrScannerCard from "./QrScannerCard";
import BalanceModal from "./BalanceModal";
import TransactionHistory from "./TransactionHistory";
import ChatPayment from "./ChatPayment";
import {
  CaretDoubleLeft,
  User,
  QrCode,
  Wallet,
  ArrowsLeftRight,
  Camera,
  SignOut,
  UserFocus
} from "phosphor-react";

const UserProfile = ({ userId, setIsAuthenticated }) => {
  const [userData, setUserData] = useState(null);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
  const [isOpen, setIsOpen] = useState(true);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const navigate = useNavigate();

  // 🔹 Auto-collapse sidebar on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const storedUserId = userId || localStorage.getItem("userId");

    if (!storedUserId || !token) return;

    const loadUser = async () => {
      try {
        const data = await fetchUserById(storedUserId, token);
        setUserData(data);
      } catch (error) {
        console.error("Fetch user failed:", error);
        if (
          error.message.includes("Unauthenticated") ||
          error.message.includes("401")
        ) {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("userId");
          localStorage.removeItem("roleId");
          setIsAuthenticated(false);
          navigate("/login");
        }
      }
    };

    loadUser();
  }, [userId, setIsAuthenticated, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("roleId");
    setIsAuthenticated(false);
    navigate("/login");
  };

  const toggleSidebar = () => setIsOpen(!isOpen);
  console.log('userData', userData);
  
  const tabs = [
    { key: "profile", label: "My Profile", icon: User },
    { key: "qr", label: "QR Code", icon: QrCode },
    ...(userData?.aws_image_id == '' || !userData?.aws_image_id
    ? [
        {
          key: "face/register",
          label: "Face Registration",
          icon: QrCode,
        },
      ]
    : []),
    { key: "wallet", label: "Wallet", icon: Wallet},
    {
      key: "transactions",
      label: "Transactions",
      icon: ArrowsLeftRight,
    },
    { key: "scan", label: "Scan QR", icon: UserFocus  },
    { key: "face-scan", label: "Scan Face", icon: Camera},
  ];

  return (
    <div className="d-flex">
      {/* ✅ Sidebar (matches Admin layout) */}
      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <div className=''>
          <div className="sidebar-header">
            <h5 className="text-xl font-500 theme-color-text">Logo</h5>
            <button className="toggle-btn" onClick={toggleSidebar}>
              <CaretDoubleLeft />
            </button>
          </div>
          <div className='sidebar-profile theme-card-gery'>
            <div className='sidebar-profile-top'>
              <div className='profie-img'>
                <span>
                  {userData?.name
                    ? userData.name.charAt(0).toUpperCase()
                    : "U"}
                </span>
              </div>
              <button onClick={() =>  ("scan")} className="qr-btn position-relative d-flex align-items-center justify-content-center rounded-circle border-0 shadow-sm" title="Scan QR Code">
                <div className="qr-glow position-absolute w-100 h-100 rounded-circle"></div>
                <QrCode className="text-white position-relative" size={24} />
              </button>
            </div>
            <div className='sidebar-profile-content pt-2'>
              {/* <span className='text-xs font-400 text-uppercase theme-text-color lts-1'>Monday, March 20</span> */}
            <span className='text-xs font-400 text-uppercase theme-text-color lts-1'>
              {new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'long',
                day: 'numeric'
              })}
          </span>
              <h2 className='text-xl font-600 theme-text-black pt-1'>
                Welcome back,
                <span className='d-block'>
                  {userData?.name || "User"}
                </span>
              </h2>
            </div>
          </div>
          <nav className="nav flex-column mt-3 gap-1 theme-card-gery sidebar-nav">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.key;
              const Icon = tab.icon;

              return (
                <button
                  key={tab.key}
                  onClick={() => {
                    if (tab.key === "face/register") {
                      navigate("/face/register");
                    }else if(tab.key === "face-scan"){
                      navigate("/face/scan");
                    }else {
                      setActiveTab(tab.key);
                    }
                  }}
                  className={`nav-link d-flex align-items-center gap-2 
                    ${isActive ? "active-link" : "text-opacity-75"}
                  `}
                >
                  <Icon
                    size={20}
                    weight={isActive ? "fill" : "regular"}
                    className={isActive ? "icon-active" : "icon-inactive"}
                  />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>
        <div className=''>
          <button
            onClick={handleLogout}
            className="log-btn theme-btn w-100"
            type="button"
          >
            <SignOut />
            <div className="d-flex flex-column text-start">
              <h6 className="pb-1">Logout</h6>
              <p className="text-xs font-400">
                Sign out securely from your account.
              </p>
            </div>
          </button>
        </div>
      </div>

      {/* ✅ Main Content */}
      <div className={`flex-grow-1 main-content transition-all ${isOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <div className="content-container">
          <main className='theme-card-gery content-wrapper'>
            {!userData ? (
              <div className="text-center text-muted mt-5">
                <div
                  className="spinner-border text-primary mb-3"
                  role="status"
                ></div>
                <p>Loading profile...</p>
              </div>
            ) : (
              <>
                {activeTab === "profile" &&
                  (!selectedPerson ? (
                    <ProfileInfo
                      userData={userData}
                      onSelectPerson={(person) => setSelectedPerson(person)}
                    />
                  ) : (
                    <ChatPayment
                      person={selectedPerson}
                      onBack={() => setSelectedPerson(null)}
                    />
                  ))}

                {activeTab === "qr" && (
                  <div className="d-flex justify-content-center align-items-center page-full-height">
                    <QrCodeCard qrCode={userData.qr_code} userData={userData} />
                  </div>
                )}

                {activeTab === "wallet" && (
                  <div className="d-flex justify-content-center align-items-center page-full-height">
                    <BalanceCard userId={userData.id} />
                  </div>
                )}

                {activeTab === "transactions" && (
                  <TransactionHistory userId={userData.id} />
                )}

                {activeTab === "scan" && (
                  <div className="d-flex justify-content-center align-items-center page-full-height">
                    <QrScannerCard
                      onScanResult={(text) => {
                        const match = text.match(/user=(\d+)/);
                        const uid = match ? match[1] : text;
                        navigate(`/topup?user=${uid}&isFaceVerified=true`);
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </main>
        </div>
      </div>

      {/* Balance Modal */}
      {showBalanceModal && (
        <BalanceModal
          userId={userId}
          onClose={() => setShowBalanceModal(false)}
          fetchUserBalance={fetchUserBalance}
        />
      )}
    </div>
  );
};

export default UserProfile;
